import React from 'react'

export default function ssl() {
    return (
        <div>
            <h1>ifc4p7fqute42ejqvg40cpkqlu</h1>
        </div>
    )
}
